module.exports = __webpack_public_path__ + "img/love-paws-homestay-omana.2d4fc4d6.jpg";